import React, { useEffect, useState } from "react"
import { Formik, Form, Field, ErrorMessage } from "formik"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Link, useLocation, useNavigate, useParams } from "react-router-dom"
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  Spinner,
} from "reactstrap"
import { addModifierOptionsSchemas } from "components/Common/validation"
import Switch from "components/Shared/Switch"
import { MultiSelect } from "primereact/multiselect"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { getAllBranchs } from "store/actions/usersAction"
import {
  addModifier,
  getModifierDetail,
  updateModifier,
} from "store/actions/modiferAction"
import { showAlert } from "store/reducers/alertReducer"
import Spinners from "components/Shared/Spinners"
import { getAllModifierGroupsList } from "store/actions/modifierGroupAction"
import Select from "react-select"
import BackButton from "components/Shared/BackButton"
import { allOption } from "components/Common/constants"
import {
  getImagePreviewSrc,
  handleFileChange,
} from "components/Shared/fileHandlers"
import { getCountryList } from "store/actions/countriesAction"
import { useTranslation } from "react-i18next"
import {
  modifierOptionHeight,
  modifierOptionSize,
  modifierOptionWidth,
} from "components/Common/ImageSize"
import TextError from "components/Shared/TextError"

const initialValues = {
  nameAr: "",
  nameEn: "",
  displayOrder: "",
  minimum: "",
  maximum: "",
  price: null,
  caloriesForCalculations: "",
  disabledBranches: "",
  // enabled: true,
  imageType: "UPLOAD",
  imageUrl: "",
  imageFile: null,
  modifierGroup: null,
  countryCode: null,
  sizeType: null,
  modifierGroupType: "", // options, sizes
  isAllowOutOfStockAction: false,
  outOfStockForBranches: [],
}

const AddModifierOption = ({ mode }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = `${
    mode === "add" || mode === "allModifierAdd" ? t("Add") : t("Edit")
  } ${t("Modifier | Namq")}`

  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const { categoryId, itemId, modifierOptionId, modifierItemId } = useParams()
  const searchParams = new URLSearchParams(location.search)
  const id = searchParams.get("id")
  const modifierType = searchParams.get("modifierType")
  const { branchsList } = useSelector(state => state.Users)
  const { modifierGroupsList } = useSelector(state => state.ModifierGroups)
  const [isAllSelected, setIsAllSelected] = useState(false)
  const { countryList } = useSelector(state => state.Countries)
  const { isImageCompressing } = useSelector(state => state.Common)

  const { accountType } = useSelector(state => state.Login)

  const [formValues, setFormValues] = useState(initialValues)
  const { loading, isLoading, modifierDetails } = useSelector(
    state => state.Modifiers
  )

  const branchListOptions = branchsList?.map(item => ({
    label: language === "sa" ? item.nameAr : item.name,
    value: item._id,
  }))

  const options = isAllSelected
    ? branchListOptions
    : [allOption, ...branchListOptions]

  useEffect(() => {
    getBranchList()
    if (mode === "edit" || mode === "allModifierEdit" || mode === "viewEdit") {
      getOldValues()
      // console.log(modifierItemId, "id")
    }
    fetchCountryList()
  }, [])

  useEffect(() => {
    if (mode === "allModifierAdd") fetchModifierGroupList()
  }, [])

  const fetchModifierGroupList = countryCode => {
    dispatch(getAllModifierGroupsList({ countryCode }))
  }

  const getBranchList = () => {
    dispatch(getAllBranchs())
  }

  const getOldValues = () => {
    const payload = {
      id: mode === "edit" || mode === "allModifierEdit" ? id : modifierItemId,
    }
    dispatch(getModifierDetail(payload))
  }

  const fetchCountryList = () => {
    dispatch(getCountryList())
  }

  // SET USER DETAILS
  useEffect(() => {
    if (
      (modifierDetails && mode === "edit") ||
      mode === "allModifierEdit" ||
      mode == "viewEdit"
    ) {
      const {
        _id,
        name,
        nameAr,
        imageUrlType,
        imageUrl,
        displayOrder,
        price,
        minimum,
        maximum,
        calorieCount,
        disabledBranches,
        status,
        countryCode,
        sizeType,
        isAllowOutOfStockAction,
        outOfStockForBranches,
      } = modifierDetails

      const outOfStockForBranchesIds =
        outOfStockForBranches?.map(branchId =>
          options.find(option => option.value === branchId)
        ) || []

      // fetchModifierGroupList(countryCode)

      const matchedCountry = countryList.find(
        item => item.countryCode === countryCode
      )
      var updatedCountryCode = null
      if (matchedCountry) {
        const { name, countryCode } = matchedCountry
        updatedCountryCode = {
          label: language === "sa" ? nameAr : name,
          value: countryCode,
        }
        fetchModifierGroupList(countryCode)
      }
      const updatedSizeType = modifierGroupsTypeList.find(
        item => item.value === sizeType
      )
      setFormValues({
        ...formValues,
        nameAr: nameAr,
        nameEn: name,
        displayOrder: displayOrder,
        minimum: minimum,
        maximum: maximum,
        price: price,
        caloriesForCalculations: calorieCount,
        outOfStockForBranches: outOfStockForBranchesIds,
        // enabled: status === 1 ? true : false,
        imageType: "UPLOAD",
        imageUrl: imageUrl,
        countryCode: updatedCountryCode,
        modifierGroupType: sizeType === 0 ? "options" : "sizes",
        sizeType: updatedSizeType,
        isAllowOutOfStockAction: isAllowOutOfStockAction || false,
      })
    }
  }, [modifierDetails, countryList, branchsList])

  const handleSubmit = values => {
    const {
      nameAr,
      nameEn,
      displayOrder,
      minimum,
      maximum,
      price,
      caloriesForCalculations,
      disabledBranches,
      // enabled,
      imageType,
      imageUrl,
      imageFile,
      modifierGroup,
      countryCode,
      sizeType,
      modifierGroupType,
      isAllowOutOfStockAction,
      outOfStockForBranches,
    } = values

    let data = new FormData()
    data.append("name", nameEn)
    data.append("nameAr", nameAr)
    data.append("modifierType", "modifier") // STATIC
    data.append("displayOrder", displayOrder)
    data.append("imageUrl", imageUrl)
    data.append("imageUrlType", imageType)
    // data.append("status", enabled ? 1 : 0)
    data.append("minimum", minimum)
    data.append("maximum", maximum)
    if (accountType === "superadmin") {
      if (outOfStockForBranches.length === 0) {
        data.append(`outOfStockForBranches[]`, [])
      } else {
        outOfStockForBranches.forEach((element, index) => {
          data.append(`outOfStockForBranches[${index}]`, element.value)
        })
      }
    }
    data.append("calorieCount", caloriesForCalculations)
    data.append("price", price)
    data.append("countryCode", countryCode?.value?.toUpperCase())
    data.append("image", imageFile)
    if (accountType === "superadmin") {
      data.append("isAllowOutOfStockAction", isAllowOutOfStockAction)
    }
    const updatedSize =
      modifierGroupType === "sizes" || modifierType === "sizes"
        ? sizeType?.value
        : 0
    data.append("sizeType", updatedSize || 0)
    // console.log(updatedSize || 0)
    if (mode === "add") {
      data.append("modifierGroup", modifierOptionId)
      dispatch(addModifier(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            navigate(-1)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    } else if (
      mode === "edit" ||
      mode === "allModifierEdit" ||
      mode === "viewEdit"
    ) {
      // data.append("modifierGroup", modifierOptionId)
      // data.append("id", mode === "edit" ? id : modifierItemId)
      data.append(
        "id",
        mode === "edit" || mode === "allModifierEdit" ? id : modifierItemId
      )
      dispatch(updateModifier(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            if (mode === "edit") {
              //
              // navigate(
              //   `/menus/categories/${categoryId}/items/${itemId}/modifiers/${modifierOptionId}/items`
              // )
              navigate(-1)
            } else {
              // navigate("/menus/modifiers")
              navigate(-1)
            }
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    } else if (mode === "allModifierAdd") {
      data.append("modifierGroup", modifierGroup.value)
      dispatch(addModifier(data))
        .then(action => {
          const { statusCode, status, msg } = action?.payload
          if (statusCode === 200 && status) {
            dispatch(showAlert({ text: msg, type: "success" }))
            // navigate("/menus/modifiers")
            navigate(-1)
          } else {
            dispatch(showAlert({ text: msg, type: "error" }))
          }
        })
        .catch(error => {})
    }
  }

  const modifierGroupsTypeList = [
    { label: t("Small"), value: 1 },
    { label: t("Regular"), value: 2 },
    { label: t("Large"), value: 3 },
    { label: t("Extra Large"), value: 4 },
  ]

  if (
    (mode === "edit" || mode === "allModifierEdit" || mode === "viewEdit") &&
    loading
  )
    return <Spinners />

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* <Breadcrumbs /> */}
        <Row>
          <Col>
            <Card>
              <CardBody>
                <CardTitle className="d-flex align-items-center">
                  <BackButton />
                  {mode === "add" || mode === "allModifierAdd"
                    ? t("Add")
                    : t("Edit")}{" "}
                  {t("Modifier Options")}
                </CardTitle>
                <Formik
                  enableReinitialize={true}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  validationSchema={addModifierOptionsSchemas(mode)}
                >
                  {({
                    errors,
                    touched,
                    values,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <Form>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="nameEn">
                              <span className="text-danger">*</span>{" "}
                              {t("Name(English)")}
                            </label>
                            <Field
                              type="text"
                              id="nameEn"
                              name="nameEn"
                              placeholder={t("Name(English)")}
                              className={`form-control ${
                                touched.nameEn && errors.nameEn
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="nameEn" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="nameAr">
                              <span className="text-danger">*</span>{" "}
                              {t("Name(عربي)")}
                            </label>
                            <Field
                              type="text"
                              id="nameAr"
                              name="nameAr"
                              style={{ direction: "rtl" }}
                              placeholder={t("Name(عربي)")}
                              className={`form-control ${
                                touched.nameAr && errors.nameAr
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="nameAr" />
                          </div>
                        </div>

                        {/* {console.log(errors)} */}

                        <div className="col-lg-6">
                          <div className="mt-2">
                            <label htmlFor="countryCode">
                              <span className="text-danger">*</span>{" "}
                              {t("Select Country")}
                            </label>
                            <Select
                              value={values.countryCode}
                              onChange={selectedValue => {
                                setFieldValue("countryCode", selectedValue)
                                fetchModifierGroupList(selectedValue.value)
                              }}
                              options={countryList?.map(item => ({
                                label:
                                  language === "sa" ? item.nameAr : item.name,
                                value: item.countryCode,
                              }))}
                              placeholder={t("Select Country")}
                              className={`select2-selection ${
                                touched.countryCode && errors.countryCode
                                  ? "danger_color_border"
                                  : ""
                              } `}
                            />
                            <TextError name="countryCode" />
                          </div>
                        </div>

                        {mode === "allModifierAdd" && (
                          <div className="col-lg-6">
                            <div className="multi_select_field">
                              <label htmlFor="modifierGroup">
                                <span className="text-danger">*</span>{" "}
                                {t("Select Modifier Group")}
                              </label>
                              <Select
                                value={values.modifierGroup}
                                isMulti={false}
                                onChange={item => {
                                  setFieldValue("modifierGroup", item)
                                  setFieldValue("modifierGroupType", item.type)
                                }}
                                options={modifierGroupsList?.map(item => ({
                                  label:
                                    language === "sa" ? item.nameAr : item.name,
                                  value: item._id,
                                  type: item.type,
                                }))}
                                className={`select2-selection ${
                                  touched.modifierGroup && errors.modifierGroup
                                    ? "border_danger"
                                    : ""
                                }`}
                                placeholder={t("Select Modifier Group")}
                              />
                              <TextError name="modifierGroup" />
                            </div>
                          </div>
                        )}
                        {(values.modifierGroupType === "sizes" ||
                          modifierType === "sizes") && (
                          <div className="col-lg-6">
                            <div className="multi_select_field">
                              <label htmlFor="sizeType">
                                {/* <span className="text-danger">*</span>{" "} */}
                                {t("Select Size Type")}
                              </label>
                              <Select
                                value={values.sizeType}
                                isMulti={false}
                                onChange={item => {
                                  setFieldValue("sizeType", item)
                                }}
                                options={modifierGroupsTypeList?.map(item => ({
                                  label: item.label,
                                  value: item.value,
                                }))}
                                className={`select2-selection ${
                                  touched.sizeType && errors.sizeType
                                    ? "border_danger"
                                    : ""
                                }`}
                                placeholder={t("Select Size Type")}
                              />
                              <TextError name="sizeType" />
                            </div>
                          </div>
                        )}

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="displayOrder">
                              <span className="text-danger">*</span>{" "}
                              {t("Display Order")}
                            </label>
                            <Field
                              type="text"
                              id="displayOrder"
                              name="displayOrder"
                              placeholder={t("Display Order")}
                              className={`form-control ${
                                touched.displayOrder && errors.displayOrder
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="displayOrder" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="minimum">
                              <span className="text-danger">*</span>{" "}
                              {t("Minimum")}
                            </label>
                            <Field
                              type="text"
                              id="minimum"
                              name="minimum"
                              placeholder="e.g. 1"
                              className={`form-control ${
                                touched.minimum && errors.minimum
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="minimum" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="maximum">
                              <span className="text-danger">*</span>{" "}
                              {t("Maximum")}
                            </label>
                            <Field
                              type="text"
                              id="maximum"
                              name="maximum"
                              placeholder="e.g. 1"
                              className={`form-control ${
                                touched.maximum && errors.maximum
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="maximum" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="price">
                              <span className="text-danger">*</span>{" "}
                              {t("Price")}
                            </label>
                            <Field
                              type="text"
                              id="price"
                              name="price"
                              placeholder="E.g. 1"
                              className={`form-control ${
                                touched.price && errors.price
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="price" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="caloriesForCalculations">
                              <span className="text-danger">*</span>{" "}
                              {t("Calories For Calculations")}
                            </label>
                            <Field
                              type="text"
                              id="caloriesForCalculations"
                              name="caloriesForCalculations"
                              placeholder="E.g. 200"
                              className={`form-control ${
                                touched.caloriesForCalculations &&
                                errors.caloriesForCalculations
                                  ? "is-invalid"
                                  : ""
                              }`}
                            />
                            <TextError name="caloriesForCalculations" />
                          </div>
                        </div>
                        {accountType === "superadmin" && (
                          <div className="col-lg-6">
                            <div className="multi_select_field">
                              <label htmlFor="outOfStockForBranches">
                                {t("Out Of Stock For Branches")}
                              </label>
                              <Select
                                value={values.outOfStockForBranches}
                                isMulti={true}
                                onChange={item => {
                                  if (
                                    item?.find(option => option.value === "*")
                                  ) {
                                    setFieldValue(
                                      "outOfStockForBranches",
                                      branchListOptions
                                    )
                                    setIsAllSelected(true)
                                  } else {
                                    setFieldValue("outOfStockForBranches", item)
                                    setIsAllSelected(
                                      item.length === branchListOptions.length
                                    )
                                  }
                                }}
                                options={options}
                                className="select2-selection"
                              />
                            </div>
                          </div>
                        )}

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="imageType">
                              {/* <span className="text-danger">*</span>{" "} */}
                              {t("Image Type")}
                            </label>
                            <Field
                              as="select"
                              id="imageType"
                              name="imageType"
                              className={`form-control ${
                                touched.imageType && errors.imageType
                                  ? "is-invalid"
                                  : ""
                              }`}
                              onChange={e => {
                                const selectedValue = e.target.value
                                setFieldValue("imageType", selectedValue)
                                // Reset the value of imageUrl and imageFile when the image type changes
                                setFieldValue("imageUrl", "")
                                setFieldValue("imageFile", null)
                              }}
                            >
                              {/* <option value="URL">{t("Image Url")}</option> */}
                              <option value="UPLOAD">
                                {t("Upload Image")}
                              </option>
                            </Field>
                            <TextError name="imageType" />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="form_field">
                            {/* IMAGE URL */}
                            {values.imageType === "URL" && (
                              <div className="form_field">
                                <label htmlFor="imageUrl">
                                  {/* <span className="text-danger">*</span>{" "} */}
                                  {t("URL")}
                                </label>
                                <Field
                                  type="text"
                                  id="imageUrl"
                                  name="imageUrl"
                                  placeholder={t("URL")}
                                  className={`form-control ${
                                    touched.imageUrl && errors.imageUrl
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                />
                                <TextError name="imageUrl" />
                              </div>
                            )}
                            {/* UPLOAD IMAGE */}
                            {values.imageType === "UPLOAD" && (
                              <div className="form_field position-relative">
                                <label htmlFor="imageFile">
                                  {/* <span className="text-danger">*</span>{" "} */}
                                  {t("Upload Image")}
                                </label>
                                <input
                                  type="file"
                                  id="imageFile"
                                  name="imageFile"
                                  accept="image/jpeg, image/jpg, image/png"
                                  className={`form-control ${
                                    touched.imageFile && errors.imageFile
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  onChange={e => {
                                    handleFileChange(
                                      e,
                                      "imageFile",
                                      setFieldValue,
                                      modifierOptionWidth,
                                      modifierOptionHeight,
                                      modifierOptionSize
                                    )
                                  }}
                                />
                                {isImageCompressing && (
                                  <Spinner
                                    color="primary"
                                    className="file_upload_btn"
                                  />
                                )}
                                <TextError name="imageFile" />
                              </div>
                            )}
                          </div>

                          {(() => {
                            const updatedMode =
                              mode === "add" || mode === "allModifierAdd"
                                ? "add"
                                : mode
                            return (
                              getImagePreviewSrc("add", values) && (
                                <div className="mt-3">
                                  <img
                                    src={getImagePreviewSrc("add", values)}
                                    alt="Preview"
                                    className="img_preview"
                                  />
                                </div>
                              )
                            )
                          })()}
                          <span>
                            {t(
                              "Recommended dimensions: Square Image and Size should be less than or equal to {{size}} KB",
                              {
                                width: modifierOptionWidth,
                                height: modifierOptionHeight,
                                size: modifierOptionSize,
                              }
                            )}
                          </span>
                        </div>
                        {/* <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="enabled">Enabled</label>
                            <Switch
                              isChecked={values.enabled}
                              onClickHandler={() => {
                                setFieldValue("enabled", !values.enabled)
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-12">
                          <span>Recommended size: 103 x 103</span>
                        </div> */}
                        {accountType === "superadmin" && (
                          <div className="col-lg-6">
                            <div className="form_field">
                              <label htmlFor="isAllowOutOfStockAction">
                                {t("Allow Out Of Stock Action")}
                              </label>

                              <Switch
                                onClickHandler={e => {
                                  setFieldValue(
                                    "isAllowOutOfStockAction",
                                    !values.isAllowOutOfStockAction
                                  )
                                }}
                                isChecked={values.isAllowOutOfStockAction}
                              />
                              <TextError name="isAllowOutOfStockAction" />
                            </div>
                          </div>
                        )}
                        <div className="mt-3"></div>
                        <Col sm={12}>
                          <div className="d-flex justify-content-end">
                            <Button
                              type="button"
                              className="mx-2"
                              color="secondary"
                              onClick={() => navigate(-1)}
                            >
                              {t("Cancel")}
                            </Button>
                            <Button
                              type="submit"
                              color="success"
                              disabled={isLoading || isImageCompressing}
                            >
                              {`${
                                mode === "add" || mode === "allModifierAdd"
                                  ? t("Add")
                                  : t("Save")
                              }`}
                            </Button>
                          </div>
                        </Col>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AddModifierOption
